import React from 'react';
import CompanyHeader from "../components/Organisms/Headers/CompanyHeader";
import BasicCompanyInformationPanel from "../components/Organisms/Panels/BasicCompanyInformationPanel";
import SubsidiaryPanel from "../components/Organisms/Panels/SubsidiaryPanel";
import UsersPanel from "../components/Organisms/Panels/UsersPanel";
import BanksPanel from "../components/Organisms/Panels/BanksPanel";
import JobsPanel from "../components/Organisms/Panels/JobsPanel";
import {useMedia} from "../hooks/useMedia";
import {mediaFromM, mediaToM} from "../helpers/media-queries";
import TabsWrapper from "../components/Wrappers/TabsWrapper";
import TabItem from "../components/Atoms/TabItem";
import PanelTemplate from "../components/Wrappers/PanelTemplate";

const Company = () => {
  const fromM = useMedia(mediaFromM)
  return (
    <main className="main ed-grid row-gap">
      <CompanyHeader />
      {fromM ? (
        <div className="ed-grid m-grid-2 lg-grid-3">
          <BasicCompanyInformationPanel />
          <SubsidiaryPanel/>
          <div className="ed-grid rows-gap">
            <UsersPanel/>
            <BanksPanel/>
            <JobsPanel/>
          </div>
        </div>
      ) : (
        <TabsWrapper>
          <div className="tabs-container">
            <TabItem index={0}>Información básica</TabItem>
            <TabItem index={1}>Sucursales</TabItem>
            <TabItem index={2}>Usuarios</TabItem>
            <TabItem index={3}>Bancos y puestos de trabajo</TabItem>
          </div>
          <PanelTemplate index={0}>
            <BasicCompanyInformationPanel />
          </PanelTemplate>
          <PanelTemplate index={1}>
            <SubsidiaryPanel/>
          </PanelTemplate>
          <PanelTemplate index={2}>
            <UsersPanel/>
          </PanelTemplate>
          <PanelTemplate index={3}>
            <div className="ed-grid rows-gap">
              <BanksPanel/>
              <JobsPanel/>
            </div>
          </PanelTemplate>
        </TabsWrapper>
      )}
    </main>
  );
};

export default Company;
